import { type TranslationTree } from '@/i18n/types';

export const messages = {
  columns: {
    event: 'Evento',
    next: 'Próxima data',
    city: 'Cidade',
    status: 'Status',
    intents: 'Pretendem ir',
    actions: 'Ações',
  },
  ended: 'Encerrado',
  // pt-BR reads 0 as "one"; the zero form keeps "0 pretendem ir".
  intents: {
    zero: '{{count}} pretendem ir',
    one: '{{count}} pretende ir',
    other: '{{count}} pretendem ir',
  },
  actions: 'Ações de {{name}}',
  open: 'Abrir',
  edit: 'Editar',
  pagination: '{{from}}–{{to}} de {{count}}',
  paginationAria: {
    first: 'Primeira página',
    last: 'Última página',
    next: 'Próxima página',
    previous: 'Página anterior',
  },
} satisfies TranslationTree;
